import 'magnific-popup';
import DOM from '@/scripts/old/modules/jqueryDOM';

// TODO: reinit function

function Popup() {
  const self = this;
  let scrollTop = 0;

  $.extend(true, $.magnificPopup.defaults, {
    tClose: '',
    tLoading: '',
    gallery: {
      arrowMarkup: '',
      tPrev: '',
      tNext: '',
      tCounter: '',
    },
    image: {
      tError: 'Ошибка при загрузке',
      markup:
        `<div class="popup popup_media js-popup">
          <div class="popup__in">
            <button type="button" class="popup__close js-popup-close"></button>
            <button type="button" class="popup__arrow popup__arrow_next js-popup-next"></button>
            <button type="button" class="popup__arrow popup__arrow_prev js-popup-prev"></button>
            <div class="popup__content">
              <div class="popup__image">
                <div class="mfp-img"></div>
              </div>
              <div class="popup__title"></div>
              <div class="popup__share"></div>
            </div>
          </div>
        </div>`,
      cursor: null,
      verticalFit: false,
    },
    iframe: {
      markup:
        `<div class="popup popup_media js-popup">
          <div class="popup__in">
            <button type="button" class="popup__close js-popup-close"></button>
            <button type="button" class="popup__arrow popup__arrow_next js-popup-next"></button>
            <button type="button" class="popup__arrow popup__arrow_prev js-popup-prev"></button>
            <div class="popup__content">
              <div class="popup__iframe-wrap">
                <iframe class="mfp-iframe popup__iframe" frameborder="0" allowfullscreen></iframe>
              </div>
              <div class="popup__title"></div>
              <div class="popup__share"></div>
            </div>
          </div>
        </div>`,
    },
    ajax: {
      tError: 'Ошибка при загрузке', // Error message when ajax request failed
    },
    autoFocusLast: false,
    showCloseBtn: false,
    fixedContentPos: true,
    mainClass: 'js-popup-wrap',
    callbacks: {
      ajaxContentAdded() {
        window.App.initModules();
        window.App.update();
      },
      markupParse(template, values, item) {
        let src = values.iframe_src;

        /** Для ссылок на youtube включим автовоспроизведение */
        if (item.type === 'iframe' && (src.indexOf('youtube') + 1 || src.indexOf('youtu.be') + 1)) {
          if (src.indexOf('autoplay=') === -1) {
            src += (src.indexOf('?') + 1) ? '&' : '?';
            src += 'autoplay=1';
          }
          if (src.indexOf('enablejsapi=') === -1) {
            src += '&enablejsapi=1';
          }
          if (src.indexOf('mute=') === -1) {
            src += '&mute=1';
          }

          values.iframe_src = src;
        }

        // Title
        const $title = template.find('.popup__title');
        $title.html('');
        const title = item.el ? item.el.data('popup-title') : item.data.title;
        if (title) {
          $title.html(title);
        }

        // Share block
        const $share = template.find('.popup__share');
        $share.html('');
        const share = item.el ? item.el.data('popup-share') : item.data.share;
        if (share) {
          const url = (item.el ? item.el.data('popup-share-url') : item.data.shareUrl) || document.location.href;
          const title = (item.el ? item.el.data('popup-share-title') : item.data.shareTitle) || '';
          const shareHtml = `<div class="popup__share share share_vertical">
              <div class="share__btns">
                <button type="button" class="share__btn share__btn_vk js-social-share" data-share="vk" data-share-url="${url}"></button>
                <button type="button" class="share__btn share__btn_fb js-social-share" data-share="fb" data-share-url="${url}"></button>
                <button type="button" class="share__btn share__btn_ok js-social-share" data-share="ok" data-share-url="${url}"></button>
                <button type="button" class="share__btn share__btn_tw js-social-share" data-share="tw" data-share-url="${url}" data-share-title="${title}"></button>
              </div>
            </div>`;
          $share.html(shareHtml);
        }
      },
      beforeOpen() {
        scrollTop = DOM.$window.scrollTop();
      },
      open() {
        DOM.$body.addClass('is-popup-opened');
      },
      close() {
        DOM.$body.removeClass('is-popup-opened');
        DOM.$window.scrollTop(scrollTop);
      },
    },
  });

  // https://stackoverflow.com/questions/19990191/select2-in-magnific-popup-search-input-cannot-be-focused
  $.magnificPopup.instance._onFocusIn = function _onFocusIn(e) {
    // Do nothing if target element is select2 input
    if ($(e.target).hasClass('select2-search__field')) {
      return true;
    }
    // Else call parent method
    return $.magnificPopup.proto._onFocusIn.call(this, e);
  };

  self.open = function open(config) {
    $.magnificPopup.open(config, 0);
  };

  // Close popup
  DOM.$document.on('click', '.js-popup-close', (e) => {
    e.preventDefault();
    $.magnificPopup.close();
  });

  // Close popup on click outside popup inner
  DOM.$document.on('click', '.js-popup', (e) => {
    if ($(e.target).hasClass('js-popup')) {
      $.magnificPopup.close();
    }
  });

  // Gallery next
  DOM.$document.on('click', '.js-popup-next', (e) => {
    e.preventDefault();
    $.magnificPopup.instance.next();
  });

  // Gallery prev
  DOM.$document.on('click', '.js-popup-prev', (e) => {
    e.preventDefault();
    $.magnificPopup.instance.prev();
  });

  self.initAll = function initAll() {

    $('.js-popup-inline').each(function () {
      $(this).magnificPopup({
        type: 'inline',
        midClick: true,
        showCloseBtn: false,
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: true,
      });
    });

    $(document).on('click', '.js-close-popup', function (e) {
      e.preventDefault();
      $.magnificPopup.close();
    });

    $('.js-popup-open').each(function initPopupSingle() {
      const $this = $(this);
      const type = $this.data('popup-type') || 'inline';

      const config = { type };
      $this.magnificPopup(config);
    });

    $('.js-popup-gallery').each(function initPopupGallery() {
      $(this).magnificPopup({
        delegate: '.js-popup-gallery__item',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
        callbacks: {
          elementParse(item) {
            const type = $(item.el).data('popup-type');
            item.type = type || 'image';
          },
        },
      });
    });

    $('.js-popup-gallery-data').each(function initPopupGalleryData() {
      const $this = $(this);
      const items = $this.data('popup-items');

      if (!items) return;

      $this.magnificPopup({
        items,
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
        callbacks: {
          elementParse(item) {
            const type = item.el ? $(item.el).data('popup-type') : item.data.type;
            item.type = type || 'image';
          },
        },
      });
    });
  };
}

export default new Popup();
